import createBreakpoint from 'shared-tokens/utils/breakpoints';

import { mainCls as detailsCls } from '../../style';

const brDesk = createBreakpoint('m');
const brLarge = createBreakpoint('l');

export const mainCls =  `${detailsCls}__title`;
export const mapCls =  `map_${detailsCls}__title`;

export default {
  [mainCls]: {
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    '&.less' : {  
      [brDesk]: {
        '-webkit-line-clamp': 1,
      },
      [brLarge]: {
        '-webkit-line-clamp': 2,
      },
    }
  },
  [mapCls]: {
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
  },  
  [`${mainCls}--a`]: {
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
    },
  },
  [`${mainCls}--bull`]: {    
    '&:after': {
      content: '"•"',
      position: 'absolute',
      top: 3,
      left: 4,
      fontSize: 10,
    }
  },
};
